import { useCallback } from 'react';
import { WEBSITE_ERRORS_BUNDLE } from '../../utils/constants';
import { resolveLocalizedError } from '../../utils/errorMessages';
import { useMessages } from '../messages';

/** Waitlist-surface fallbacks in the website.errors bundle, for an error with no messageKey. */
export const WAITLIST_LOAD_FAILED_KEY = 'error_waitlist_loadFailed';
export const WAITLIST_REMOVE_FAILED_KEY = 'error_waitlist_removeFailed';
export const WAITLIST_JOIN_FAILED_KEY = 'error_waitlist_joinFailed';
export const WAITLIST_LEAVE_FAILED_KEY = 'error_waitlist_leaveFailed';

/**
 * Resolves a caught error or a partial-failure detail to localized display text via the
 * `website.errors` bundle. Use anywhere the UI would otherwise show a raw error string. Pass
 * `fallbackId` (e.g. WAITLIST_LOAD_FAILED_KEY) to pick the generic shown when the error has no key.
 */
export function useErrorMessages(): {
  resolveError: (error: unknown, fallbackId?: string) => string;
  isLoading: boolean;
} {
  const { format, isLoading } = useMessages(WEBSITE_ERRORS_BUNDLE);
  const resolveError = useCallback(
    (error: unknown, fallbackId?: string): string =>
      resolveLocalizedError(error, format, fallbackId),
    [format]
  );
  return { resolveError, isLoading };
}
